import store from '../store';
/* eslint-disable */
export default async function increaseTemplateQuestionsCounter(template, type) {
    let length = type !== 'slides' ? template.value.questions[type].questions.length : null;
    let count = template.value.questions[type].counter;
    if(length !== null){
        if (length > count){
            template.value.questions[type].counter =  length;
            template.value.questionsCount += 1;
        }
    }else{
        if (count < 1){
            template.value.questions[type].counter += 1;
            template.value.questionsCount += 1;
        }
    }
    if( template.value.questionsCount > 0){
        await store.dispatch('setDataFlag', true);
        await store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
    }else{
        await store.dispatch('setDataFlag', false);
    }
}
